module.exports = ".wrapper{margin-top:3rem;margin-bottom:3rem}.select-project{display:flex;width:100%}.select-project .label{font-weight:800;width:200px;flex-shrink:0}.field-select{flex:1}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/access-management/project-comittee-handler/project-comittee-handler.component.scss
// module id = ./src/app/access-management/project-comittee-handler/project-comittee-handler.component.scss
// module chunks = access-management.module